import { render, staticRenderFns } from "./VxBreadcrumb.vue?vue&type=template&id=046ae61b&scoped=true&functional=true"
import script from "./VxBreadcrumb.vue?vue&type=script&lang=js"
export * from "./VxBreadcrumb.vue?vue&type=script&lang=js"
import style0 from "./VxBreadcrumb.vue?vue&type=style&index=0&id=046ae61b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "046ae61b",
  null
  
)

export default component.exports